// extracted by mini-css-extract-plugin
export default {"pageHeader":"H9G0uoT8qCq0OwOBNkZi","backButton":"M_EtbfyfUfowf9mlQExB","rightSection":"eFwuMJYiVPxQuTIPKxUU"};